(function () {
    'use strict';

    angular
        .module('franchisee.components')
        .controller('PeopleListController', PeopleListController)

    /** @ngInject */
    function PeopleListController($q, $rootScope, $scope, AccessLevelService, ResponsabilityService, PersonService, AuthenticationService, HelperService, DEFAULT_IDENTIFIERS, SYSTEM_MODULES, DATA_EVENTS) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedAccessLevel || vm.selectedResponsability || (vm.selectedSearchField && vm.searchText))
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedAccessLevel || vm.selectedResponsability || vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedAccessLevel = null;
            vm.selectedResponsability = null;
            vm.selectedSearchField = null;
            vm.searchText = null;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            if (vm.isFirstCall)
                return;

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getPeople(start, number, tableState);
        }

        vm.orderPersonResponsibilities = personUnits => {
            let filteredPersonUnits = [];

            for (let index = 0; index < personUnits.length; index++) {
                const personUnit = personUnits[index];
                let foundFPU = filteredPersonUnits.find(fpu => (fpu.ResponsibilityId == personUnit.ResponsibilityId));

                //The logged user can only see the data from the selected user
                if (vm.loggedUserData.UnitId != personUnit.UnitId) continue;

                if (foundFPU) {
                    foundFPU.Units.push(personUnit.Unit)
                } else {
                    filteredPersonUnits.push({
                        ResponsibilityId: personUnit.ResponsibilityId,
                        Responsibility: personUnit.Responsibility,
                        Units: [personUnit.Unit]
                    })
                }
            }

            return filteredPersonUnits;
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            initVars();

            vm.doSearch(null, true);
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getPeople(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            PersonService
                .getByParameters(parameters)
                .then(success => {
                    vm.people = success.People;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.units = null;
                    vm.isLoading = false;
                    HelperService.errorCallback(error);
                })
        }

        function getAccessLevels() {
            AccessLevelService
                .getAll()
                .then(success => {
                    vm.accessLevels = success.filter(level => (level.Id == DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE || level.Id == DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE_WORKER));
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.custom-filters');
                })
        }

        function getResponsabilities() {
            return ResponsabilityService
                .getAll()
                .then(success => {
                    vm.responsabilities = success;
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.custom-filters');
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'Name',
                OrderDescending: false,
                UnitId: vm.loggedUserData.UnitId
            }

            if (vm.selectedAccessLevel || vm.selectedResponsability || vm.selectedUnit || (vm.selectedSearchField && vm.searchText))
                isTableSearch = true;

            if (vm.selectedAccessLevel)
                params.AccessLevelId = vm.selectedAccessLevel.Id;

            if (vm.selectedResponsability)
                params.ResponsabilityId = vm.selectedResponsability.Id;

            if (tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Value;
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function initVars() {
            vm.loggedUserData = AuthenticationService.getSelectedData();
            vm.canUserHandlePerson = AuthenticationService.getUnitDataByAccessLevelAndModuleId(vm.loggedUserData.AccessLevelId, SYSTEM_MODULES.FRANCHISEE_PEOPLE).length > 0;
            vm.selectedResponsability;
            vm.selectedAccessLevel;
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;

            vm.searchFields = [{
                Value: 'Document',
                Description: 'Documento'
            }, {
                Value: 'Name',
                Description: 'Nome'
            }, {
                Value: 'Email',
                Description: 'E-mail'
            }];
        }

        function init() {
            initVars();

            HelperService.startLoading('.custom-filters');

            $q.all([getAccessLevels(), getResponsabilities()])
                .then(() => {
                    HelperService.stopLoading('.custom-filters');
                })
        }
    }
}());